"use client";

import React from "react";
// import UpdatedHeader from "@/components/common/UpdatedHeader";
import QuickContact from "@/components/common/QuickContact";
import BridgeBanner from "@/components/pageComponent/bridge-course/deskBanner";
import BridgeEligibilty from "@/components/pageComponent/bridge-course/bridge-eligibility";
import BridgeProgram from "@/components/pageComponent/bridge-course/bridge-program";
import BridgeTable from "@/components/pageComponent/bridge-course/bridge-table";
import BridgeUni from "@/components/pageComponent/bridge-course/bridge-uni";
import BridgeContact from "@/components/pageComponent/bridge-course/bridge-contact";
import EventTicker from "@/components/common/EventTicker";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";

export interface FormProps {
  submitButtonName: string;
  formTitle: string | false;
  showWebinar: boolean;
  popupName?: boolean;
  PopupId?: number;
  popupUserId?: null | number;
}

const DesktopPage: React.FC = () => {
  return (
    <main className="bg-white w-full">
      <div className="w-full">
        <EventTicker />
      </div>
      <GlobalHeaderNew />
      <BridgeBanner />
      <BridgeEligibilty />
      <BridgeProgram />
      <BridgeTable />
      <BridgeUni />
      <BridgeContact />
      <GlobalFooter />
      <QuickContact />
    </main>
  );
};

export default DesktopPage;
